import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-001e3434")

_pushScopeId("data-v-001e3434")
const _hoisted_1 = {
  key: 0,
  class: "blinking",
  style: {"display":"inline-flex","width":"0px"}
}
const _hoisted_2 = {
  key: 1,
  style: {"visibility":"hidden"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", null, _toDisplayString(_ctx.underConstruction), 1),
    (_ctx.notdone)
      ? (_openBlock(), _createBlock("span", _hoisted_1, "|"))
      : _createCommentVNode("", true),
    (_ctx.keepWidth)
      ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.widthString), 1))
      : _createCommentVNode("", true)
  ], 64))
})